import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-accessibility',
  templateUrl: './accessibility.component.html',
  styleUrls: ['./accessibility.component.scss'],
  // eslint-disable-next-line @angular-eslint/prefer-standalone -- kept NgModule-based (AccessibilityModule); converting to standalone is out of scope for this change
  standalone: false
})
export class AccessibilityComponent implements OnInit {
  currentFontSize = 'sm';
  private readonly fontSizes: string[] = ['sm', 'md', 'lg'];
  isPopoverOpen = false;

  ngOnInit(): void {
    const savedFontSize = localStorage.getItem('fontSizePreference');
    if (savedFontSize) {
      this.currentFontSize = savedFontSize;
      this.applyFontSize(savedFontSize);
    } else {
      this.applyFontSize('sm');
    }
  }

  onButtonClick(): void {
    this.isPopoverOpen = !this.isPopoverOpen;
  }

  onPopoverToggle(event: unknown): void {
    let isOpen: boolean;

    if (typeof event === 'boolean') {
      isOpen = event;
    } else if (event && typeof event === 'object') {
      const eventObj = event as Record<string, unknown>;
      isOpen = !!(eventObj['opened'] || eventObj['value'] || eventObj['isOpen']);
    } else {
      isOpen = false;
    }

    this.isPopoverOpen = isOpen;
  }

  setFontSize(size: string): void {
    this.currentFontSize = size;
    this.applyFontSize(size);
    localStorage.setItem('fontSizePreference', size);
  }

  increaseFontSize(): void {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    if (currentIndex < this.fontSizes.length - 1) {
      const nextSize = this.fontSizes[currentIndex + 1];
      this.setFontSize(nextSize);
    }
  }

  decreaseFontSize(): void {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    if (currentIndex > 0) {
      const prevSize = this.fontSizes[currentIndex - 1];
      this.setFontSize(prevSize);
    }
  }

  isIncreaseFontSizeDisabled(): boolean {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    return currentIndex >= this.fontSizes.length - 1;
  }

  isDecreaseFontSizeDisabled(): boolean {
    const currentIndex = this.fontSizes.indexOf(this.currentFontSize);
    return currentIndex <= 0;
  }

  private applyFontSize(size: string): void {
    const root = document.documentElement;
    let multiplier = 1;

    switch (size) {
      case 'sm':
        multiplier = 0.875;
        break;
      case 'md':
        multiplier = 1;
        break;
      case 'lg':
        multiplier = 1.25;
        break;
    }

    root.style.setProperty('--font-size-multiplier', multiplier.toString());

    // Keep body classes for specific overrides
    document.body.classList.remove('font-sm', 'font-md', 'font-lg');
    document.body.classList.add(`font-${size}`);
  }

}
